import { render, staticRenderFns } from "./DistanceBlock.vue?vue&type=template&id=22791413"
import script from "./DistanceBlock.vue?vue&type=script&lang=js"
export * from "./DistanceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports